import { render, staticRenderFns } from "./IcpFooter.vue?vue&type=template&id=5f1b0b59&scoped=true"
import script from "./IcpFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./IcpFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IcpFooter.vue?vue&type=style&index=0&id=5f1b0b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b0b59",
  null
  
)

export default component.exports